import { computed } from 'vue';
import Services from '@/data/services.json';
import ServicesHost from '@/data/services-host.json';
import ServicesFenOgren from '@/data/services-fenogren.json';

export default function useUrl() {
  const getServices = computed(() => {
    if (import.meta.env.VITE_SERVICES === 'local') {
      return Services;
    } else {
      if (import.meta.env.VITE_SITE === 'fenogren') {
        return ServicesFenOgren;
      } else {
        return ServicesHost;
      }
    }
  });

  // Kazanım servisini bul
  const url = (url = false) => {
    let id = url ? `dersapp-${url}` : 'dersapp';
    const service = getServices.value.find(service => service.id === id);
    return service?.url;
  };

  const login = (url = false) => {
    let id = url ? `dersapp-${url}` : 'dersapp';
    const service = getServices.value.find(service => service.id === id);
    return service?.loginUrl;
  };

  const logo = computed(() => {
    let site = import.meta.env.VITE_SITE;
    return `/logo-${site}.png`;
  });

  return {
    url,
    login,
    logo,
    getServices
  };
} 